import { DoubleArrow, Search } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import CustomerForm from './CustomerForm';
import { useAppData } from '../../../../../context/AppDataContext';
import { Autocomplete, TextField } from '@mui/material';
import customerServices from '../customerServices';

function SelectCustomer({callBack,selectedCustomer,setSelectedCustomer}) {

  const {customerDD,getCustomerDD} = useAppData();

  const onCreateNew = (customerId) =>{
    customerServices.getById(customerId).then(res=>{
      let _selectedCustomer = {
        "value":res.data.id,
        "label":res.data.customerName
      }
      setSelectedCustomer(_selectedCustomer);
      console.log(_selectedCustomer);
      getCustomerDD();
    }).catch(error=>{
      console.log(error)
    })
  }

  
  

  return (

    <div className='row'>
      <div className='col-md-6'>
        <Autocomplete
            options={customerDD}
            onChange={(event, newValue) => {
                setSelectedCustomer(newValue);
            }}
            className='bg-white'
            value={selectedCustomer}
            renderInput={(params) => <TextField {...params} size="small" label='Select Customer' /> } 
        />
      </div>
      <div className='col-md-6'>
        <span className='mx-2'>OR</span>
        <CustomerForm callBackWithId={onCreateNew} />
      </div>
    </div>

  )
}

export default SelectCustomer